import styled, { css } from 'styled-components';
import Typography from 'ggApp/shared/components/typography';
import { HelpIcon } from 'ggApp/shared/icons/help';

export const SingleProductWrapper = styled.div`
    display: flex;
    position: relative;
    z-index: 1;
    align-items: flex-start;
    flex-direction: row;

    ${({ big }) => big && css`
        width: inherit;
    `}

    ${({ absolute }) => absolute
        && css`
            flex-direction: column;
            position: absolute;
            top: 0;
            left: 0;
        `}

    ${({ withBorderBottom }) => withBorderBottom
        && css`
            border-bottom: 1px solid #eaeaea;
        `}
`;

export const ProductImage = styled.div`
    background-image: ${props => `url(${props.img || ''})`};
    width: 120px;
    height: 100px;
    background-size: auto 100px;
    background-position: 50%;
    background-repeat: no-repeat;
    align-self: flex-start;
    cursor: ${({ onClick }) => onClick && 'pointer'};
    padding: ${({ theme }) => theme.spacers.L} 0 ${({ theme }) => theme.spacers.L} ${({ theme }) => theme.spacers.XL};
    flex-shrink: 0;

    ${({ big }) => big
        && css`
            width: 200px;
            height: 200px;
            background-size: contain;
            background-position: 50% 50%;
            padding: ${({ theme }) => theme.spacers.XXL};
            flex-shrink: 1;
        `}

    ${({ mobile }) => mobile
        && css`
            width: 30%;
        `}

    ${({ desktopColumn }) => desktopColumn
        && css`
            padding: 0;
        `}
`;

export const ProductName = styled(Typography).attrs({
    tag: 'h3',
})`
    cursor: ${({ onClick }) => onClick && 'pointer'};
    font-family: Inter, sans-serif;
    color: ${({ theme }) => theme.colors.background};

    ${({ big }) => big
        && css`
            font-size: 24px;
            line-height: 29px;
        `}
`;

export const ProductCoreAttribute = styled(Typography).attrs({
    tag: 'h4',
})`
    color: ${({ theme }) => theme.colors['Level 5']};
    padding: ${({ theme }) => theme.spacers.M} 0;

    ${({ big }) => big
        && css`
            font-size: 16px;
            line-height: 24px;
        `}
`;

export const TextWrapper = styled.div`
    padding: ${({ theme }) => theme.spacers.L};
    align-self: flex-start;

    ${({ absolute }) => absolute
        && css`
            padding: 0 ${({ theme }) => theme.spacers.XXL};
        `}

    ${({ mobile }) => mobile
        && css`
            width: 70%;
            margin-left: auto;
            margin-right: 0;
        `}
`;

export const ToolTipWrap = styled.div`
    display: flex;
    flex-wrap: wrap;

    svg {
        height: 15px;
        width: 15px;
        margin-left: ${({ theme }) => theme.spacers.S};
    }
`;

export const ToolTipText = styled(Typography).attrs({
    tag: 'h4',
})`
    color: ${({ theme }) => theme.colors['Level 4']};
    padding-bottom: ${({ theme }) => theme.spacers.M};
    text-decoration: underline;
    font-weight: bold;
    cursor: help;
`;

export const Icon = styled(HelpIcon)`
    height: 15px;
    width: 15px;
    margin-left: ${({ theme }) => theme.spacers.S};
`;
